// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
.resource-type-deck img {
	opacity: 0.4 !important;
}

.resource-type-deck:hover img {
	opacity: 0.7 !important;
}
`, "",{"version":3,"sources":["webpack://./css/collections.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n.resource-type-deck img {\n\topacity: 0.4 !important;\n}\n\n.resource-type-deck:hover img {\n\topacity: 0.7 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
